import { render, staticRenderFns } from "./join_1.vue?vue&type=template&id=0e5db27a&scoped=true&"
import script from "./join_1.vue?vue&type=script&lang=js&"
export * from "./join_1.vue?vue&type=script&lang=js&"
import style0 from "./join_1.vue?vue&type=style&index=0&id=0e5db27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5db27a",
  null
  
)

export default component.exports